import { Component, OnInit } from '@angular/core';
import { SportService } from '../services/sport.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-edit-stack',
  templateUrl: './edit-stack.component.html',
  styleUrls: ['./edit-stack.component.scss']
})
export class EditStackComponent implements OnInit {
  submitted = false;
  userDetails: any;
  userMatchStack: any;
  match_stack: any[] = [];
  constructor(private sportService: SportService,private toastr: ToastrService,) { }

  ngOnInit(): void {
    this.userDetails = JSON.parse(localStorage.getItem('userDetails'));
    this.getUserMatchStackDetails()
  }

  getUserMatchStackDetails() {
    this.sportService.getUserMatchStack(this.userDetails._id).subscribe(response => {
      if (response.status == true) {
        this.userMatchStack = response.data
        this.match_stack = this.userMatchStack.match_stack
      } else {
        this.toastr.error(response.msg, '', {
          positionClass: 'toast-top-center',
          timeOut: 1000
        });
      }

    })
  }

  updateUserMatchStack() {
    let stackRequest = {
      // "userid": this.userDetails._id,
      "match_stack": this.match_stack
    }
    this.sportService.updateUserMatchStack(stackRequest).subscribe(result => {
      if (result.status == true) {
        this.submitted = false;
        this.toastr.success(result.msg, '', {
          positionClass: 'toast-top-center',
          timeOut: 1000
        });
      } else {
        this.toastr.error(result.msg, '', {
          positionClass: 'toast-top-center',
          timeOut: 1000
        });
      }
    })
  }

  trackByFn(index: any, item: any) {
    return index;
  }

}
